import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWeddingState, IWeddingVenue } from "./weddingModel";
import {
  getAllActiveWeddingVenues,
  getWeddingVenueByURL,
} from "./services/wedding.services";

const initialState: IWeddingState = {
  loading: false,
  error: "",
  WeddingVenueList: [],
  WeddingVenueDetails: {},
};

const weddingVenueSlice = createSlice({
  name: "weddingVenue",
  initialState,
  reducers: {
    clearWeddingVenueList: (state) => {
      state.WeddingVenueList = initialState.WeddingVenueList;
    },
    setWeddingVenueList: (state, action: PayloadAction<any[]>) => {
      state.WeddingVenueList = action.payload || [];
      state.loading = false;
    },
    setWeddingVenueDetails: (state, action: PayloadAction<any>) => {
      state.WeddingVenueDetails = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveWeddingVenues.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveWeddingVenues.fulfilled,
      (state, action: PayloadAction<IWeddingVenue[]>) => {
        state.loading = false;
        state.WeddingVenueList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveWeddingVenues.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WeddingVenueList = [];
    });

    builder.addCase(getWeddingVenueByURL.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getWeddingVenueByURL.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.WeddingVenueDetails = action.payload;
      },
    );
    builder.addCase(getWeddingVenueByURL.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WeddingVenueDetails = state.WeddingVenueDetails;
    });
  },
});

export const {
  clearWeddingVenueList,
  setWeddingVenueDetails,
  setWeddingVenueList,
} = weddingVenueSlice.actions;
export default weddingVenueSlice.reducer;
